export default __webpack_public_path__ + "static/title-news-ja-00b75a983db50f3c4a0e1ac340534b7b.png";